import { makeStyles } from 'tss-react/mui';

export const useSettingsStyles = makeStyles()((theme) => ({
  fontWeight500: {
    fontWeight: 500
  },
  phoneTable: {
    width: 'fit-content',
    '& td': {
      padding: 0,
      borderBottom: 'none',
    },
    '& td:not(:last-of-type)': {
      paddingRight: theme.spacing(2)
    },
    '& tr:not(:last-of-type) td': {
      paddingBottom: theme.spacing(0.5)
    }
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: '400px'
  },
  maxWidth120: {
    maxWidth: '120px'
  },
  maxWidth140: {
    maxWidth: '140px'
  },
  disabledTextInput: {
    background: theme.palette.grey[200],
    color: theme.palette.text.primary
  }
}));
